import { useT } from '@/i18n/provider';
import { useCookieConsent } from '@/hooks/useCookieConsent';
import { Button } from '@/components/ui/Button';
import { LocalizedAnchor } from '@/components/LocalizedLink';
import { Cookie } from 'lucide-react';

export function CookieBanner() {
  const t = useT();
  const { consent, accept, decline } = useCookieConsent();

  if (consent !== null) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-50 p-4 sm:p-6">
      <div className="mx-auto max-w-2xl rounded-2xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 shadow-xl p-5 sm:p-6">
        <div className="flex items-start gap-4">
          <div className="hidden sm:flex shrink-0 mt-0.5 h-10 w-10 items-center justify-center rounded-full bg-primary-50 dark:bg-primary-900/30">
            <Cookie className="h-5 w-5 text-primary-600 dark:text-primary-400" />
          </div>
          <div className="flex-1 space-y-3">
            <p className="text-sm text-gray-600 dark:text-gray-300 leading-relaxed">
              {t('cookie.message')}{' '}
              <LocalizedAnchor
                href="/privacy"
                className="font-medium text-primary-600 dark:text-primary-400 underline underline-offset-2 hover:text-primary-700 dark:hover:text-primary-300"
              >
                {t('cookie.privacyLink')}
              </LocalizedAnchor>
            </p>
            <div className="flex gap-3">
              <Button size="sm" onClick={accept}>
                {t('cookie.accept')}
              </Button>
              <Button variant="outline" size="sm" onClick={decline}>
                {t('cookie.decline')}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
